/*
 * @Description: 
 * @Date: 2025-11-10 16:10:38
 * @LastEditTime: 2026-08-10 09:40:36
 * @FilePath: \hui_ai_ui\src\utils\sourceClickDirective.js
 */
/**
 * Vue指令：处理.it_source元素的点击事件
 */
export const sourceClickDirective = {
  // 指令被绑定到元素上时
  bind(el, binding, vnode) {
    // console.log('v-source-click指令已绑定到元素:', el);
    // console.log('绑定的回调函数:', binding.value);
    
    // 定义点击事件处理函数
    const handleClick = (event) => {
      // console.log('捕获到点击事件，目标元素:', event.target);
      
      // 检查点击的元素是否有href属性且以http开头
      const aTag = event.target.closest('a[href^="http"]');
      // console.log('a标签:', aTag);
      if (aTag) {
        // 已经是a标签且href以http开头，设置target="_blank"确保在新窗口打开
        aTag.target = '_blank';
        // console.log('a标签已设置target="_blank"',aTag);
        // 不阻止默认行为，让浏览器正常打开链接
        return;
      }
      
      // 处理思考内容的展开/收起功能 - 所有模型都支持后端返回 <think> 标签
      const toggleEl = event.target.closest('.thinking-toggle');
      if (toggleEl) {
        event.stopPropagation();
        const contentEl = toggleEl.nextElementSibling;
        if (contentEl && contentEl.classList.contains('thinking-content')) {
          const toggleIcon = toggleEl.querySelector('.toggle-icon');
          
          if (contentEl.style.display === 'none') {
            contentEl.style.display = 'block';
            // 文字保持为"思考内容"，只切换图标
            if (toggleIcon) {
              toggleIcon.className = 'toggle-icon el-icon-arrow-down';
              toggleIcon.style.fontSize = '10px';
            }
          } else {
            contentEl.style.display = 'none';
            // 文字保持为"思考内容"，只切换图标
            if (toggleIcon) {
              toggleIcon.className = 'toggle-icon el-icon-arrow-right';
              toggleIcon.style.fontSize = '10px';
            }
          }
        }
        return; // 阻止后续处理，直接返回
      }
      
      // 检查点击的元素是否是.it_source类的元素或其子元素
      const target = event.target.closest('.it_source');
      // console.log('找到的.it_source元素:', target);
      
      if (target) {
        // 阻止默认行为
        event.preventDefault();
        
        // 获取属性值
        const historyId = target.getAttribute('history_id');
        const sourceFileId = target.getAttribute('source_file_id');
        // console.log('获取到的属性值:', { historyId, sourceFileId });
        
        // 确保属性存在
        if (historyId && sourceFileId) {
          // console.log('Source clicked:', { historyId, sourceFileId });
          
          // 调用绑定的回调函数，type 首位便于读取
          if (typeof binding.value === 'function') {
            binding.value('it_source', historyId, sourceFileId, event);
          } else {
            // 默认处理逻辑
            // console.log(`处理资源点击: ${historyId}, 文件ID: ${sourceFileId}`);
            // console.log('警告：未绑定回调函数');
          }
        } else {
          // console.log('警告：缺少必要的属性值');
        }
      } else { // event.target.closest('.it_note_source');
        // 检查点击的元素是否是.it_note_source类的元素或其子元素
        const noteTarget = event.target.closest('.it_note_source');
        if (noteTarget) {
          event.preventDefault();
          const noteId = noteTarget.getAttribute('source_note_id');
          if (noteId) {
            if (typeof binding.value === 'function') {
              binding.value('it_note_source', noteId, null, event);
            }
          }
        } else {
          // console.log('点击的不是.it_source或.it_note_source元素');
        }
      }
    };
    
    // 存储事件处理函数到元素上，以便在unbind时移除
    el._sourceClickHandler = handleClick;
    
    // 添加事件监听器（使用事件委托）
    //console.log('添加点击事件监听器');
    el.addEventListener('click', handleClick);
  },
  
  // 当元素更新时（对于动态内容很重要）
  update(el, binding) {
    // console.log('v-source-click指令更新，新的回调函数:', binding.value);
  },
  
  // 指令与元素解绑时
  unbind(el) {
    // console.log('v-source-click指令解绑');
    // 移除事件监听器
    if (el._sourceClickHandler) {
      el.removeEventListener('click', el._sourceClickHandler);
      delete el._sourceClickHandler;
      // console.log('点击事件监听器已移除');
    }
  }
};

/**
 * 注册全局指令
 * @param {Vue} Vue - Vue实例
 */
export function registerSourceClickDirective(Vue) {
  Vue.directive('source-click', sourceClickDirective);
}